import { defineMessages } from 'react-intl'

export default defineMessages({
  success: {
    id: 'containers.CustomerTeamPage.InviteUserModal.success',
    defaultMessage: 'Success',
  },
  invitationsSent: {
    id: 'containers.CustomerTeamPage.InviteUserModal.invitationsSent',
    defaultMessage: 'Invitations has been sent to the users.',
  },
  close: {
    id: 'containers.CustomerTeamPage.InviteUserModal.close',
    defaultMessage: 'Close',
  },
  name: {
    id: 'containers.CustomerTeamPage.InviteUserModal.name',
    defaultMessage: 'Name',
  },
  namePlaceholder: {
    id: 'containers.CustomerTeamPage.InviteUserModal.namePlaceholder',
    defaultMessage: 'Enter name',
  },
  email: {
    id: 'containers.CustomerTeamPage.InviteUserModal.email',
    defaultMessage: 'Email',
  },
  emailPlaceholder: {
    id: 'containers.CustomerTeamPage.InviteUserModal.emailPlaceholder',
    defaultMessage: 'you@example.com',
  },
  phone: {
    id: 'containers.CustomerTeamPage.InviteUserModal.phone',
    defaultMessage: 'Phone',
  },
  add: {
    id: 'containers.CustomerTeamPage.InviteUserModal.add',
    defaultMessage: 'Add more',
  },
  invite: {
    id: 'containers.CustomerTeamPage.InviteUserModal.invite',
    defaultMessage: 'Send invites',
  },
})